module.exports = __webpack_public_path__ + "img/1.6a4185d9.jpg";